module.exports = __webpack_public_path__ + "static/media/selected_add.332a8299.png";